import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription, filter } from 'rxjs';
import {
  trigger,
  style,
  animate,
  transition,
  state,
} from '@angular/animations';

import { TopLevelNavMenuItem } from '../../models/navigation.model';

@Component({
  selector: 'app-dynamic-top-level-nav',
  templateUrl: './dynamic-top-level-nav.component.html',
  animations: [
    trigger('slideInOut', [
      // slightly adjusted for the rounded container look
      state('void', style({ height: '0px', opacity: 0 })),
      state('*', style({ height: '*', opacity: 1 })),
      transition('void <=> *', animate('300ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
    trigger('fadeIn', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(-5px)' }),
        animate(
          '200ms ease-out',
          style({ opacity: 1, transform: 'translateY(0)' })
        ),
      ]),
    ]),
  ],
})
export class DynamicTopLevelNavComponent implements OnInit, OnDestroy {
  @Input() forceSkeletonLoader: boolean = false;
  @Input() customClasses: string = '';
  @Input() disableTopRound: boolean = true;
  @Input() disableBorder: boolean = true;
  detectedActiveItem = false;
  currentMenuItem: TopLevelNavMenuItem | undefined;
  _menuItems: TopLevelNavMenuItem[] = [];
  isMobileMenuOpen: boolean = false;
  subscriptions: Subscription[] = [];

  @Input('menuItems') set MenuItems(value: TopLevelNavMenuItem[]) {
    this._menuItems = value;
    value.forEach((item) => {
      if (!item.randId) item.randId = Math.random().toString(36).substring(7);
    });
    this.determineActiveItem();
  }

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.trackRouterEvents();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  trackRouterEvents() {
    this.subscriptions.push(
      this.router.events
        .pipe(filter((event) => event instanceof NavigationEnd))
        .subscribe((event: NavigationEnd) => {
          this.determineActiveItem(event.url, true);
          this.isMobileMenuOpen = false; // Close mobile menu on navigate
        })
    );
  }

  onClickMainItem(item: TopLevelNavMenuItem) {
    if (item?.soon) return;
    this.currentMenuItem = item;
  }

  determineActiveItem(currentUrl = this.router.url, force: boolean = false) {
    if (!this.detectedActiveItem || force) {
      const item = this._menuItems.find((a) => currentUrl.includes(a.url));
      if (item) {
        this.onClickMainItem(item);
        this.detectedActiveItem = true;
      }
    }
  }
}
